
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#252626","fill-rule":"evenodd","d":"M2.56 11.05l5.75 5.74-1.06 1.06a.5.5 0 01-.71 0l-5.39-5.39a.5.5 0 010-.71l.7-.7a.5.5 0 01.71 0zm20.29-4.51l-.7-.71a.51.51 0 00-.71 0l-9.55 9.55-1.08-1.08 7-7a.5.5 0 000-.71l-.7-.71a.51.51 0 00-.71 0l-7 7.05-1.84-1.88a.5.5 0 00-.71 0l-.7.7a.5.5 0 000 .71l5.39 5.39a.5.5 0 00.71 0l10.6-10.6a.5.5 0 000-.71z"}})])
          )
        }
      }
    